import React, { Component } from 'react';
import Layout from '../Layout';

export default class Contact extends Component {
  render() {
    return(
      <Layout mainhero="">
      <div className="section is-medium section-feature-grey">
          <div className="container">
              <div className="section-title-wrapper has-text-centered">
                  <h2 className="title is-2">Demo Talebi</h2>
                  <h4 className="subtitle is-4">Ask us a question, or just say Hello.</h4>
              </div>
              <div className="columns">
                  <div className="column is-6">
                      <div className="contact-form">
                          <form>
                              <div className="columns is-multiline">
                                  <div className="column is-6">
                                      <div className="control">
                                          <label>First name *</label>
                                          <input className="input is-medium" type="text" />
                                      </div>
                                  </div>
                                  <div className="column is-6">
                                      <div className="control">
                                          <label>Last name *</label>
                                          <input className="input is-medium" type="text" />
                                      </div>
                                  </div>
                                  <div className="column is-6">
                                      <div className="control">
                                          <label>Email *</label>
                                          <input className="input is-medium" type="email" />
                                      </div>
                                  </div>
                                  <div className="column is-6">
                                      <div className="control">
                                          <label>Company</label>
                                          <input className="input is-medium" type="text" />
                                      </div>
                                  </div>
                                  <div className="column is-12">
                                      <div className="control">
                                          <label>Message *</label>
                                          <textarea className="textarea" rows="4"></textarea>
                                      </div>
                                  </div>
                              </div>
                              <div className="submit-wrapper">
                                  <a href="#" className="button button-cta is-bold btn-align secondary-btn raised">
                                      Send Message
                                  </a>
                              </div>
                          </form>
                      </div>
                  </div>
                  <div className="column is-5 is-offset-1">
                      <div className="contact-toggler">
                          <ul className="tabbed-links">
                              <li className="is-active" data-contact="contact-email">Email</li>
                              <li data-contact="contact-location">Location</li>
                              <li data-contact="contact-phone">Phone</li>
                          </ul>
                          <div className="contact-blocks">
                              <div id="contact-email" className="contact-block animated preFadeInUp fadeInUp">
                                  <div className="contact-icon">
                                      <i className="fa fa-envelope"></i>
                                  </div>
                                  <div className="contact-info">
                                      <span>Contact us by email</span>
                                      <span>hello@bulkit.io</span>
                                  </div>
                              </div>
                              <div id="contact-location" className="contact-block animated preFadeInUp fadeInUp is-hidden">
                                  <div className="contact-icon">
                                      <i className="fa fa-map"></i>
                                  </div>
                                  <div className="contact-info">
                                      <span>Visit us @ our Office</span>
                                      <span>87, Cours Charlemagne, Lyon, FRANCE</span>
                                  </div>
                              </div>
                              <div id="contact-phone" className="contact-block animated preFadeInUp fadeInUp is-hidden">
                                  <div className="contact-icon">
                                      <i className="fa fa-phone"></i>
                                  </div>
                                  <div className="contact-info">
                                      <span>Call our Support team</span>
                                      <span>+33 4 56 89 89</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <img src="assets/images/illustrations/drawings/line-city.svg" alt="" />
                  </div>
              </div>
          </div>
      </div>


      </Layout>
    );
  }
};
